import React, { useState } from "react";

// core
import { version } from "../../core/config";

// components
import { SidebarItem } from "./SidebarItem";

export const Sidebar = (props) => {
  const [showSideBar, setShowSideBar] = useState(false);
  const items = [
    { key: "dashboard", name: "داشبورد", link: "/" },
    { key: "products", name: "کالاها", link: "/products/" },
    { key: "sites", name: "فروشگاه‌ها", link: "/sites/" },
  ];

  return (
    <div className="sidebar">
      <button
        className="sidebar-button"
        onClick={() => setShowSideBar(!showSideBar)}>
        {showSideBar ? (
          <i className="far fa-times"></i>
        ) : (
          <i className="far fa-square"></i>
        )}
      </button>
      <div className={showSideBar ? "content show-sidebar" : "hide-sidebar"}>
        {items.map((item) => (
          <SidebarItem isActive={props.activeItem === item.key} {...item} />
        ))}
        <div className="version">
          <small>نسخه {version}</small>
        </div>
      </div>
    </div>
  );
};
